import type { DateInput } from '@repo/common';

import { CalendarContextProvider } from '../../contexts/CalendarContext';
import { CalendarMonthAndYearPicker } from '../CalendarMonthAndYearPicker/CalendarMonthAndYearPicker';
import { YearlyMonthGrid } from './YearlyMonthGrid/YearlyMonthGrid';

import './YearlyCalendar.scss';

interface YearlyCalendarProps {
  onMonthSelect: (month: DateInput) => void;
  /** Month to open on and highlight; defaults to today. */
  initialDate?: Date;
}

export function YearlyCalendar({ onMonthSelect, initialDate }: YearlyCalendarProps) {
  const handleMonthClick = (month: DateInput) => {
    // Trigger the onMonthSelect callback with the selected month.
    onMonthSelect(month);
  };

  return (
    <CalendarContextProvider periodType="year" initialDate={initialDate}>
      <div className="YearlyCalendar">
        <div className="YearlyCalendar__top-content">
          <CalendarMonthAndYearPicker labelType="body-large-bold" />
          <YearlyMonthGrid onMonthClick={handleMonthClick} />
        </div>
      </div>
    </CalendarContextProvider>
  );
}
